



















































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IGuest } from "@/@types/admin/guest/user";
import { IRoom } from "@/@types/hotel/room";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";
import { pensioners } from "@/config/main.config.json";
import identity_cards from "@/config/identity/identity_cards";
import { calculateAge as getAge } from "@/services/dateTime/ages";
import { getDate, getBirthday } from "@/services/dateTime/getFullDate";
import {
  isValidPassport,
  isValidBirthCertificate,
} from "@/services/user/personal_data";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: { StandartModal },
})
export default class RoomCard extends Vue {
  @Prop({ type: Array, default: () => [] }) rooms!: Array<IRoom>;
  @Prop({ type: Array, default: () => [] }) guests!: Array<IGuest>;
  @Prop({ type: Object, default: null }) vrooma!: IVirtualRooma;
  @Prop({ type: String, default: "" }) id!: string;
  @Prop({ type: Date, default: () => new Date() }) date!: Date;

  show_comment = false;
  show_gender = false;
  show_email = false;
  show_order_number = false;
  show_ad = false;
  show_phone_number = true;
  show_birthday = true;
  show_document = true;
  show_age = true;

  get guestList(): Array<IGuest> {
    if (this.vrooma) {
      const guests = [];
      for (const guest_id of this.vrooma.guests) {
        const guest = this.guests.find((g) => g._id == guest_id);
        if (guest) guests.push(guest);
      }
      return guests;
    }

    const guests: Array<IGuest> = [];
    this.guests.forEach((guest) => {
      if (guest.stay_data?.room?.id != this.id) return;
      if (!guest.stay_data.arrival || !guest.stay_data.departure) return;

      const arrival = new Date(guest.stay_data.arrival);
      const departure = new Date(guest.stay_data.departure);
      if (this.date >= arrival && this.date <= departure) guests.push(guest);
    });
    return guests;
  }

  get room(): Partial<IRoom> {
    const room = this.rooms.find((el) => el._id == this.id);
    return room ? room : { _id: this.id };
  }

  fullName(guest: IGuest): string {
    const pd = guest.personal_data;
    if (!pd) return "";
    return [pd.surname, pd.first_name, pd.second_name]
      .filter(Boolean)
      .join(" ");
  }

  initials(guest: IGuest): string {
    const pd = guest.personal_data;
    if (!pd) return "?";
    const surname = (pd.surname || "").charAt(0);
    const first = (pd.first_name || "").charAt(0);
    return `${surname}${first}`.toUpperCase() || "?";
  }

  age(guest: IGuest): number | null {
    if (!guest.personal_data || !guest.personal_data.birthday) return null;
    return getAge(guest.personal_data.birthday);
  }

  genderLabel(guest: IGuest): string {
    const gender = guest.personal_data && guest.personal_data.gender;
    if (!gender) return "";
    return String(this.$tc(`main.gender.${gender}`, 2));
  }

  phone(guest: IGuest): string {
    return (guest.additional_data && guest.additional_data.phone_number) || "";
  }

  internetPhone(guest: IGuest): string {
    return (
      (guest.additional_data && guest.additional_data.phone_internet_access) ||
      ""
    );
  }

  email(guest: IGuest): string {
    return (guest.additional_data && guest.additional_data.email) || "";
  }

  orderNumber(guest: IGuest): string {
    return (guest.stay_data && guest.stay_data.order_number) || "";
  }

  arrival(guest: IGuest): string {
    if (!guest.stay_data || !guest.stay_data.arrival) return "";
    return getDate(guest.stay_data.arrival);
  }

  departure(guest: IGuest): string {
    if (!guest.stay_data || !guest.stay_data.departure) return "";
    return getDate(guest.stay_data.departure);
  }

  birthday(guest: IGuest): string {
    if (!guest.personal_data || !guest.personal_data.birthday) return "";
    return getBirthday(guest.personal_data.birthday);
  }

  docNumber(guest: IGuest): string {
    if (
      !guest.personal_data?.documents ||
      !guest.personal_data.documents.number
    )
      return "";
    const num = guest.personal_data.documents.number;
    const doctype = guest.personal_data.documents.doctype;
    if (doctype === null || doctype === undefined) return num;

    // Паспорт РФ
    if (doctype == identity_cards[0]._id) {
      const length = num.length;
      if (length > 4) return num.slice(0, 4) + " " + num.slice(4);
    }
    // Свидетельство о рождении
    if (doctype == identity_cards[4]._id) {
      const index = num.search(/\d/);
      if (index !== -1) return num.slice(0, index) + " " + num.slice(index);
    }

    return num;
  }

  docColor(guest: IGuest): string {
    if (!guest.personal_data?.documents) return "";
    const doctype = guest.personal_data.documents.doctype;
    if (doctype === null || doctype === undefined) return "";
    // Паспорт РФ
    if (doctype == identity_cards[0]._id) {
      if (!isValidPassport(guest.personal_data.documents.number))
        return "text-danger";
    }
    // Свидетельство о рождении
    if (doctype == identity_cards[4]._id) {
      if (!isValidBirthCertificate(guest.personal_data.documents.number))
        return "text-danger";
    }
    return "";
  }

  guestBg(guest: IGuest): string {
    if (!guest?.personal_data?.birthday) return "";
    const age = this.age(guest);
    if (age === null) return "";
    if (age < 18) return "#e3f2fd";
    // pensioners
    if (!guest.personal_data.gender) return "";
    if (guest.personal_data.gender == 1 && age >= pensioners.men)
      return "#fff8e1";
    if (guest.personal_data.gender == 2 && age >= pensioners.women)
      return "#fff8e1";
    return "";
  }

  async deleteGuest(guest: IGuest): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.tc("Guests.List.buttons.delete", 1)),
        }
      );

      if (result === true) this.$emit("deleteguest", guest._id);
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  rememberSaved(): void {
    const s_birthday = localStorage.getItem("guest_show_birthday");
    if (s_birthday) this.show_birthday = parseInt(s_birthday) ? true : false;

    const show_gender = localStorage.getItem("guest_show_gender");
    if (show_gender) this.show_gender = parseInt(show_gender) ? true : false;

    const show_comment = localStorage.getItem("guest_show_comment");
    if (show_comment) this.show_comment = parseInt(show_comment) ? true : false;

    const show_doc = localStorage.getItem("guest_show_document");
    if (show_doc) this.show_document = parseInt(show_doc) ? true : false;

    const show_pn = localStorage.getItem("guest_show_phone_number");
    if (show_pn) this.show_phone_number = parseInt(show_pn) ? true : false;

    const show_email = localStorage.getItem("guest_show_email");
    if (show_email) this.show_email = parseInt(show_email) ? true : false;

    const show_on = localStorage.getItem("guest_show_order_number");
    if (show_on) this.show_order_number = parseInt(show_on) ? true : false;

    const show_ad = localStorage.getItem("guest_show_ad");
    if (show_ad) this.show_ad = parseInt(show_ad) ? true : false;

    const show_age = localStorage.getItem("guest_show_age");
    if (show_age) this.show_age = parseInt(show_age) ? true : false;
  }

  mounted(): void {
    this.rememberSaved();
  }
}
